import { user } from './user'
import { session } from './session'
import { esr } from './eventSource'
import { login } from './login'
import { config } from './config'
import { share } from './share'

export default { user, session, esr, login, config, share }
